import type { User } from '@war-game/contracts';
import { create } from 'zustand';

interface AuthState {
  token: string | null;
  user: User | null;
  ready: boolean;
  setSession: (token: string, user: User) => void;
  setReady: () => void;
  clear: () => void;
}

/** Access token só em memória; o refresh token fica no cookie httpOnly. */
export const useAuth = create<AuthState>((set) => ({
  token: null,
  user: null,
  ready: false,
  setSession: (token, user) => set({ token, user, ready: true }),
  setReady: () => set({ ready: true }),
  clear: () => set({ token: null, user: null, ready: true }),
}));
